import styled from 'styled-components'

export const Container = styled.img`
  width: 288px;
  height: 8.4vh;
  object-fit: contain;
  object-position: left;
`
